import * as actionTypes from './actionTypes';

const initialState = {
  key: '',
  results: [],
  facets: [],
  queryParams: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SEARCH:
      return {
        ...state,
        key: action.key,
      };
    case actionTypes.SEARCH_SUCCESS:
      return {
        ...state,
        results: action.results,
        facets: action.facets,
        queryParams: {
          ...state.queryParams,
          sortBy: action.sortBy || 'relevance',
          ...action.facets.reduce(
            (obj, facet) => ({
              ...obj,
              [facet.key]: facet.values.reduce(
                (agg, item) => (item.active ? item.name : agg),
                null,
              ),
            }),
            {},
          ),
        },
      };
    default:
      return state;
  }
};
